import { useState } from 'react';
import { Transition } from '@headlessui/react';

export default function Tooltip({ children, content, className = '' }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <span
      className="relative"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
    >
      <span className="cursor-default" tabIndex={0} role="button" aria-expanded={isOpen}>
        {children}
      </span>
      <Transition
        show={isOpen}
        enter="transition duration-150 ease-out"
        enterFrom="scale-95 opacity-0"
        enterTo="scale-100 opacity-100"
        leave="transition duration-100 ease-in"
        leaveFrom="scale-100 opacity-100"
        leaveTo="scale-95 opacity-0"
      >
        <div
          role="tooltip"
          className={`absolute right-0 top-full z-50 mt-2 w-max max-w-xs rounded-lg bg-gray-800 px-3 py-2 text-xs leading-snug text-gray-200 shadow-lg ring-1 ring-white/10 ${className}`}
        >
          {content}
        </div>
      </Transition>
    </span>
  );
}
